var initializeStatsBlock = function(block){

	setupCountUpScrollTriggers(block);

}

//initialize each block on front end
jQuery(document).ready(function(){
	jQuery('.wp-block-stats').each(function(){
		initializeStatsBlock(jQuery(this));
	});
});

//initialize dynamic block preview in the editor
if(window.acf)
	window.acf.addAction('render_block_preview/type=stats', initializeStatsBlock);


function setupCountUpScrollTriggers(block){

	const elements = document.querySelectorAll('.auto-counter:not(.set-up)');
	
	if ('IntersectionObserver' in window) {
	
		const options = {
			root: null,
			rootMargin: '0px 0px 0px 0px',
			threshold: 0
		};
		
		var observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if(entry.isIntersecting) {
					entry.target.classList.add('active');
					startStatCounter(block);
				} 
			});
		}, options);
		
		elements.forEach(element => {
			element.classList.add('set-up');
			observer.observe(element);
		});
		
	} else {
		
		for(var i=0; i<elements.length; i++) {
			elements[i].classList.add('set-up');
			elements[i].classList.add('active');	
		}
		
	}

}

function startStatCounter(block) {
	
	jQuery('.auto-counter.not-counting', block).each(function(){

		var current = jQuery(this);
		var number = jQuery('.number', current);

		current.removeClass('not-counting');
		
		var targetNumber = number.data('target-number');
		var increment = parseInt(targetNumber/40);
	
		var stat = setInterval(function(){
			countUp(number, increment, targetNumber, stat); 
		}, 40);
		
	});
	
}	

function countUp(container, increment, goal, interval) {
	
	var num = parseInt(container.html().replace(/,/g, ""));

	goal = parseInt(goal);	
	num += increment;
	
	if(num > goal)
		num = goal;
	
	container.html(numberWithCommas(num));
	
	if(num == goal)
		clearInterval(interval);	
}			

function numberWithCommas(x) {
	
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    
}
